import Article from "../typescript/modules/article";
import ArticleLoader from "../typescript/modules/article-loader";
import SimpleTabs from "../../../../Site/gulp/scripts/typescript/modules/simple-tabs";
import Slideshow from "../../../../Site/gulp/scripts/typescript/modules/slideshow";
import NewsletterSubscription from "../../../../Site/gulp/scripts/typescript/modules/newsletter-subscription";
import GlobalHeader from "../../../../Site/gulp/scripts/typescript/modules/global-header";

new GlobalHeader();
new ArticleLoader();
new SimpleTabs();
const slideshows = document.querySelectorAll('.js-slideshow') as NodeListOf<HTMLElement>;
for (let i = 0; i < slideshows.length; i++) {
	new Slideshow(slideshows[i]);
}

const newsletterForms = document.querySelectorAll(".js-newsletter-form") as NodeListOf<HTMLFormElement>;

for (let i = 0; i < newsletterForms.length; i++) {
	let form = newsletterForms[i];

	if (form) {
		new NewsletterSubscription(form);
	}
}

new Article();

